export const PFLICHTFELDMARKER : string = '\u002A ';
export const MIN_PWD_LENGTH: number = 8;
